import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { setDateWithTimezone } from 'client/utils/date-time-format'
import { userDataQuery } from 'src/editor/api/queries/user-data-query'

interface UseDateWithTimezoneProps {
  date: Date
  onChange: (date: Date) => void
}

export const useDateWithTimezone = ({
  date,
  onChange,
}: UseDateWithTimezoneProps) => {
  const { data: user } = userDataQuery.useQuery()
  const userTimeZone =
    useManagement(managementSelectors.getUserTimezone) || user?.timezone

  if (!userTimeZone) {
    throw new Error('User timezone is not set')
  }

  const dateWithTimezone = setDateWithTimezone({
    date,
    timeZone: userTimeZone,
  })

  const onChangeWithTimezone = (date: Date) =>
    onChange(
      setDateWithTimezone({
        date,
        timeZone: userTimeZone,
        subtract: true,
      }),
    )

  return { dateWithTimezone, onChangeWithTimezone }
}
